import { useEffect, useState } from "react";
import { fetchAllJobs } from "../../apis/JobApis";
import HorizontalSection from "../jobs/HorizontalSection";
import { FaBriefcase, FaHandshake, FaGraduationCap } from "react-icons/fa";
import { useTheme } from "../Theme/ThemeContext";

export default function Recents() {
  const [recentJobs, setRecentJobs] = useState([]);
  const [recentReferrals, setRecentReferrals] = useState([]);
  const [recentInternships, setRecentInternships] = useState([]);
  const { currentTheme } = useTheme();

  useEffect(() => {
    fetchAllJobs({ size: 4, type: "job" }).then((data) => {
      setRecentJobs(data.jobs);
    });

    fetchAllJobs({ size: 4, type: "referral" }).then((data) => {
      setRecentReferrals(data.jobs);
    });

    fetchAllJobs({ size: 4, type: "internship" }).then((data) => {
      setRecentInternships(data.jobs);
    });
  }, []);

  return (
    <section className="py-16 bg-white dark:bg-neutral-900">
      <div className="ca-container">
        {/* Section header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-theme-primary/10 rounded-full text-theme-primary text-sm font-semibold mb-4">
            
            Latest Opportunities
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-neutral-900 dark:text-white mb-4">
            Fresh <span className={`bg-gradient-to-r ${currentTheme.colors.gradient} bg-clip-text text-transparent`}>Opportunities</span>
          </h2>
          <p className="text-neutral-600 dark:text-neutral-400 text-lg max-w-2xl mx-auto">
            Discover the latest jobs, referrals, and internships added to our platform.
          </p>
        </div>
        
        <div className="space-y-12">
          <HorizontalSection 
            title="Recent Jobs" 
            posts={recentJobs} 
            icon={<FaBriefcase className="w-5 h-5" />}
            gradient={currentTheme.colors.gradient}
          />
          <HorizontalSection 
            title="Recent Referrals" 
            posts={recentReferrals}
            icon={<FaHandshake className="w-5 h-5" />}
            gradient={currentTheme.colors.gradient}
          />
          <HorizontalSection 
            title="Recent Internships" 
            posts={recentInternships}
            icon={<FaGraduationCap className="w-5 h-5" />}
            gradient={currentTheme.colors.gradient}
          />
        </div>
      </div>
    </section>
  );
}
